<template>
<section>
 
<el-container>

  <el-container>
    <el-main >
      
        <div style="float:left">
 <el-form label-width="80px">
          
         <el-row type="flex" class="row-bg" style="text-align: center">
              <el-form-item label="客户" v-show="searchConsumerVisible">
                    <el-select v-model="filters.CustomerIds"   placeholder="请选择客户"  >
                    <el-option
                        v-for="item in customerList"
                        :label="item.customName"
                        :value="item.id"
                        :key="item.id"
                    ></el-option>
                    </el-select>
               </el-form-item>
         </el-row>
        <el-row type="flex" class="row-bg" style="text-align: center">
          <el-form-item>
            <!-- 上传文件 -->
            <el-upload ref="upload"
              class="upload-demo"
              drag
              action="string"
              :http-request="UploadExcel"
              :limit="1"
              accept=".xls,.xlsx"
              :auto-upload="false"
               :file-list="fileList"
              :before-upload="onBeforeUploadExcel"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <!-- <div class="el-upload__tip" slot="tip">
                只能上传.xls,.xlsx文件
              </div> -->
            </el-upload>
          </el-form-item>
        </el-row>
        <el-row type="flex" class="row-bg" style="text-align: center">
          <el-form-item>
            <el-button type="primary" @click="handleDownload"
              >下载导入模板</el-button>
           
          </el-form-item>
            <el-form-item>
               <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
            </el-form-item>
        </el-row>
        <!-- 上传显示进度条 -->
        <el-row type="flex" class="row-bg" style="text-align: center">
          <div v-show="progressFlag" class="head-img" style="width: 150px">
            <el-progress
              :text-inside="true"
              :percentage="progressPercent"
              status="success"
            ></el-progress>
          </div>
        </el-row>
        <el-row type="flex" class="row-bg">
          <span style="color: red"> {{ Importtext }}</span>
        </el-row>
     </el-form>
        </div>
        <div style="float:left;margin-left:10px;width: 50%;">
            <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>操作说明</span>
                
            </div>
            <div  class="text item">
            <p>1. 仅支持xls、xlsx格式的文档，建议使用平台兼容浏览器，如Chrome，FireFox。</p>
        
            <p>2. 产品及服务更新较频繁，为避免出现问题，建议每次下载最新的模板进行批量导入。</p>

            <p>3. 建议每次导入数量不超过1000条，单量较大时处理需要3-5分钟，请耐心等待，无需重复导入。</p> 

            <p>4. 如还有疑问可以参看注释或联系在线客服。</p>
            </div>
            </el-card>
        
        </div>

     
    </el-main>
  
  </el-container>
</el-container>

      </section>
</template>

<script>

    import util from '../../../util/date'
    import { getCustomerList} from '@/api/ProductSkuExcel.js';
import {
    DownloadDeliveryInfoExcelTemplate,ImportDeliveryInfo
} from "@/api/receive/pcReceiveExport.js";

    import { getButtonList } from "../../promissionRouter";
    import axios from "axios";
    import Toolbar from "../../components/Toolbar";
export default {
    components: { Toolbar },
    data(){
        return {
             Importtext: "", //导入返回信息
             progressFlag: false, //进度条初始值隐藏
             progressPercent: 0, //进度条初始值
             customerList:[],
             searchConsumerVisible:false,
             filters: {CustomerIds:''},
             buttonList: [],
             typeVisible: false,
             fileList:[]
                        
        }

    },
    methods:{
      callFunction(item) {
            // this.filters = {
            //     keyword: item.search
            // };
            this[item.func].apply(this, item);
            },
    //区分登录账号是运营服务商还是客户
    initVisibleCustomName:function(){
        var user = JSON.parse(window.localStorage.user);
                  if (user && user.id > 0){
                    this.searchConsumerVisible = user.organizationType===20||user.organizationType===30;
                  }
      },
          //文件上传前验证
    onBeforeUploadExcel(file) {
     
      console.log(file);
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "xls";
      const extension2 = testmsg === "xlsx";
      // const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2) {
        this.$message({
          message: "导入文件只能是 xls、xlsx格式!",
          type: "error",
        });
      }

      return extension || extension2;
    },
//上传文件
    UploadExcel(param) {

      // if(this.filters.CustomerIds==0||this.filters.CustomerIds==null||this.filters.CustomerIds==''){
      //     this.$message({
      //         message: "请选择客户",
      //         type: "error",
      //       });
      //       return;
      // }
      console.log(param, "文件");
      let para = new FormData();
      para.append("file", param.file);
      // para.append("customerId", 2);
      para.append("customerId", this.filters.CustomerIds);
      this.progressFlag = true;
      var _this = this;
      axios({
        url: ImportDeliveryInfo,
        method: "post",
        data: para,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          // progressEvent.loaded:已上传文件大小
          // progressEvent.total:被上传文件的总大小
          //进度条
          this.progressPercent =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
        },
      })
        .then((res) => {
          this.Importtext = res.data.msg;
          console.log(this.Importtext);
          if (res.data.success) {
            console.log("导入成功");
            param.onError(); // 上传成功的文件会显示绿色的对勾
            this.importVisible = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            
          } else {
            this.$message({
              message: res.data.msg+"请修改数据重新导入",
              type: "error",
            });
            param.onError();
          }
          this.progressFlag = false;
          this.progressPercent = 0;
        })
        .catch((error) => {
          this.progressFlag = false;
          this.progressPercent = 0;
          this.$message({
            message: "文件导入失败，请重试",
            type: "error",
          });
          param.onError();
        });
    },

    submitUpload(){
      this.$refs.upload.submit();
      // console.log(this.fileList);
      // if(this.fileList.length==0){
      //   this.$message({
      //       message: "请添加上传文件",
      //       type: "error",
      //     });
      // }else{
       
      // }
        
    },
    GetCustomerDrowList(){
                let para = {
                     IsAll:false
                };
                getCustomerList(para).then((res) => {
                    this.customerList= res.data.response;

                });
   },
    //下载模板
    handleDownload() {
      let url = DownloadDeliveryInfoExcelTemplate;
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.click();
      // 删除添加的a链接
      let objLink = document.getElementById("downloadLink");
      document.body.removeChild(objLink);
    },
    },
     mounted(){
           this.initVisibleCustomName();
           this.GetCustomerDrowList();

             
         

              let user = JSON.parse(window.localStorage.user);
            console.info(user)
            this.typeVisible = user.isSa;

            let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
            this.buttonList = getButtonList(this.$route.path, routers);
     }
}
</script>

<style>

</style>